export default __webpack_public_path__ + "static/media/background.c26f3553.jpg";